import Vue from 'vue'

import formatDate from '@/plugins/filters/formatDate'
import formatDateTime from '@/plugins/filters/formatDateTime'
import formatMonth from '@/plugins/filters/formatMonth'
import formatDayOfWeek from '@/plugins/filters/formatDayOfWeek'
import formatDeliveryFrequency from '@/plugins/filters/formatDeliveryFrequency'
import formatDeliveryTimeSlot from './filters/formatDeliveryTimeSlot'
import formatEnum from './filters/formatEnum'

Vue.filter('formatDate', formatDate)
Vue.filter('formatDateTime', formatDateTime)
Vue.filter('formatMonth', formatMonth)
Vue.filter('formatDayOfWeek', formatDayOfWeek)
Vue.filter('formatDeliveryFrequency', formatDeliveryFrequency)
Vue.filter('formatDeliveryTimeSlot', formatDeliveryTimeSlot)
Vue.filter('formatEnum', formatEnum)
